// ApiStats.js
import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const ApiStats = ({ latency = [], failures = 0, uniqueUsers = [], totalRequests = 0 }) => {
    const stats = [
        { title: 'Latency', value: latency[0]?.avgLatency || 0, subtitle: 'Last 24 hours' },
        { title: 'Unique Users', value: uniqueUsers[0]?.uniqueUsers || 0, subtitle: 'Last 24 hours' },
        { title: 'Requests', value: totalRequests || 0, subtitle: 'Last 24 hours', label: 'request(s)' },
        { title: 'Failures', value: failures || 0, subtitle: 'Last 24 hours', label: 'error(s)' },
    ];

    return (
        <div className='latencyWrap position-relative'>
            <Row >
                {stats?.map((stat, idx) => (
                    <Col md={6} key={idx} className="my-3">
                        <Card className="text-center">
                            <Card.Body className='p-0'>
                                <p className='d-flex flex-column'>
                                    {stat.title} <span className="float-end text-[5px]">({stat.subtitle})</span>
                                </p>
                                <h4>{stat.value}</h4>
                                {stat.label && <div className="text-muted small">{stat.label}</div>}
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default ApiStats;
